import React, { useState } from "react";
import S from "./Gallery.styled";

import { MainInner, MainSection, motionAnimation } from "@/styles/global";
import { IWPImage } from "@/src/types";
import { BackgroundImage, Figcaption, Image } from "@/styles/components";
import { Body } from "@/styles/typography";
import { motion } from "framer-motion";

type ImageGroup = {
  image: IWPImage;
  imageText?: string;
  textBackground: "fill" | "gradient";
};

export interface GalleryProps {
  blockId: string;
  image1: ImageGroup;
  image2: ImageGroup;
  image3: ImageGroup;
  image4: ImageGroup;
  image5: ImageGroup;
}

const Gallery: React.FC<GalleryProps> = ({
  blockId = "",
  image1,
  image2,
  image3,
  image4,
  image5,
}) => {
  const renderImage = (image: ImageGroup, index: number) => {
    return (
      <S.ImageContainer>
        <Image
          image={image.image}
          textBackground={image.textBackground}
          imageText={image.imageText}
          height="100%"
          width="100%"
        />
      </S.ImageContainer>
    );
  };

  return (
    <S.Section id={blockId} as={motion.section} {...motionAnimation}>
      <MainInner>
        <S.Grid>
          <S.Image1>{renderImage(image1, 1)}</S.Image1>
          <S.Image2>{renderImage(image2, 2)}</S.Image2>
          <S.Image3>{renderImage(image3, 3)}</S.Image3>
          <S.Image4>{renderImage(image4, 4)}</S.Image4>
          <S.Image5>{renderImage(image5, 5)}</S.Image5>
        </S.Grid>
      </MainInner>
    </S.Section>
  );
};

export default Gallery;
